import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import { LayoutPlugin } from 'bootstrap-vue'
import { NavbarPlugin } from "bootstrap-vue";
import { CarouselPlugin } from "bootstrap-vue";

import VueAnalytics from "vue-analytics";

Vue.config.productionTip = false;

Vue.use(LayoutPlugin)
Vue.use(NavbarPlugin);
Vue.use(CarouselPlugin);
Vue.use(VueAnalytics, {
  id: "G-H33C4VPX73",
  router
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");

import "./custom.scss";
